import { ISpineData, SpineBase, clone, IObject, ingenuity, detectDeviceEnvironmentConstants } from "@quest/base-core";
import { BigWinView } from "@quest/murka-games-behavior-panther/dist";
import { constants } from "@quest/base-core/dist/detectDeviceEnvironment/Constants";

export class BigWinViewGame extends BigWinView {
  private coinShowerContainerMask:any;
  constructor(viewJson: IObject) {
    super(viewJson);
    this.resize({ data: ingenuity.deviceEnv.update() });
  }

  // Overrided to initialize game end elements
  protected initialiseElements(): void {
    super.initialiseElements();
    this.bigWinTextContainer = this.getContainerByID("bigWinCharContainer");
    this.coinShowerContainerMask = this.getShapeById("coinShowerContainerMask") as any;

    // this.bigWinTextContainer.mask = this.getShapeById("winMask");
  }

  // Overrided to apply max scale
  protected resize(evt: any): void {
    super.resize(evt);
    if (ingenuity.deviceEnv.getOrientation() !== constants.ORIENTATION.PORTRAIT) {
      const heightScale: number = innerHeight / ingenuity.configData.height;
      this.scale.set(heightScale);
      this.scaleComponents();
    }
    this.changeMeterParent();
    this.addRemoveCoinMask();
  }

  addRemoveCoinMask():void{
    if(!this.bigWinMainContainer) return;
    if (ingenuity.deviceEnv.getOrientation() !== detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
    this.bigWinMainContainer.mask = this.coinShowerContainerMask;
    }
  }

  // Add to create spine
  public createBigWinSpine(spineId: string): SpineBase {
    let bigWinObj: ISpineData = clone(this.json[spineId]);
    bigWinObj.type = "spine";
    let bigWinSpine: SpineBase = this.createSpine(bigWinObj);
    bigWinSpine.visible = false;
    return bigWinSpine;
  }
}
